import { PreRequisite } from '../../common/models/pre-requisite/pre-requisite';
import { PreRequisiteProgress } from '../../common/models/pre-requisite/pre-requisite-progress';
import { CashbackMyProgressContent } from './cashback-my-progress';

export class CashbackStoreModel {
    preRequisite: PreRequisite;
    preRequisiteProgress: PreRequisiteProgress;
    myProgressContent: CashbackMyProgressContent;
}
